import * as m from "mithril";
import { NavBar } from '../../components/NavBar';
import AppContext from '../../context/AppContext';
import { SearchForm, SearchFormModel } from '../../components/SearchForm';
import SearchCriteria, { LocationType } from '../../models/SearchCriteria';
import { ActionItemDescriptor } from "../../components/MaterialDesignComponents";
import './Home.scss';
import buildLanguageChangeActions from "../common/LanguageNavActions";
import { SourceLocationDTO } from "../../apiclient/ApiDtos";
import TopTabBar from "../../components/TopTabBar";
import { SpinnerOverlay } from "../paymentselection/SelectedPaymentModal";

interface Attrs {
    appContext: AppContext,
    shouldShakeNewFeatureTab : boolean;
    isSearchingSmallCar: boolean,
    isBackAllowed: boolean,
    sourceLocations: SourceLocationDTO[],
    shuttleSources: SourceLocationDTO[],
    searchFormModel: SearchFormModel,
    promoImageUrl?: string,    
    shouldAnimateSmallCarTitle?: boolean,
    isSearchLoading: boolean,
    onLocationSelectionRequested: (locationType: LocationType) => void,
    onChangeCarType: (isSearchingSmallCar: boolean) => void,
    onSearch: (searchCriteria: SearchCriteria) => void,
    onBackPressed: () => void,
    onDevModeRequested: () => void,
    collapsedActionItems: ActionItemDescriptor[],
}

let numberOfTimesOnHomePage = 0;

function HomePage(): m.Component<Attrs> {
    let devModeEnablingClickCount = 0;
    numberOfTimesOnHomePage++;

    let bookingCategoryIndex = 0;

    return {
        view(vnode) {
            let messageProvider = vnode.attrs.appContext.getMessageProvider();

            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);
            if(vnode.attrs.isSearchingSmallCar){
                bookingCategoryIndex = 1;
            }

            return [
                m("div.app-layout",
                    [
                        m(NavBar, {
                            title: messageProvider.get("title"),
                            canBackPress: vnode.attrs.isBackAllowed,
                            actionItems: langChangeActionItems,
                            collapsedActionItems: vnode.attrs.collapsedActionItems,
                            onBackPressed: () => {
                                vnode.attrs.onBackPressed();
                            }
                        }),

                        m(TopTabBar, {
                            showAsShakeForNewFeatureTab : vnode.attrs.shouldShakeNewFeatureTab,
                            initialSelectedTabIndex: bookingCategoryIndex, //formModel.isSmallCar ? 1 : 0,
                            tabLabels: [
                                { label: messageProvider.get("search_form.type_express_bus"), iconType: "bus" },
                                { label: messageProvider.get("search_form.type_small_car"), iconType: "car", isNewFeature: true }                                
                            ],
                            onChange: (selectedIndex) => {
                                bookingCategoryIndex = selectedIndex;

                                if(navigator.vibrate) {
                                    navigator.vibrate(10);
                                }
                                vnode.attrs.onChangeCarType(bookingCategoryIndex==1)

                            }
                        }),

                        m("div.app-area-main", [
                            vnode.attrs.isSearchLoading && m(SpinnerOverlay),
                            m(SearchForm, {
                                messageProvider: messageProvider,
                                shouldAnimateSmallCarTitle: vnode.attrs.shouldAnimateSmallCarTitle,
                                isSearchingSmallCar: bookingCategoryIndex== 1,
                                formModel: vnode.attrs.searchFormModel,
                                isSearchLoading: vnode.attrs.isSearchLoading,
                                onSourceLocationClick: () => {
                                    vnode.attrs.onLocationSelectionRequested('source');
                                },
                                onDestinationLocationClick: () => {
                                    vnode.attrs.onLocationSelectionRequested('destination');
                                },
                                onSearchClick: (searchCriteria: SearchCriteria) => {
                                    vnode.attrs.onSearch(searchCriteria);
                                }
                            }),

                            /* (numberOfTimesOnHomePage <= 1)?
                            m(PromoBox, {                                    
                                promoImageUrl:vnode.attrs.promoImageUrl,
                            }):null, */

                        ]),

                        m("div.app-area-footer", [

                            m("div.text-center",
                                m("img", {
                                    style: "height:28px",
                                    src: "https://www.mmbusticket.com/assets/images/logos/mmbusticket-logo-text-sm.png",
                                    onclick: (event) => {
                                        event.preventDefault();
                                        devModeEnablingClickCount = devModeEnablingClickCount + 1;
                                        if (devModeEnablingClickCount == 5) {
                                            vnode.attrs.onDevModeRequested();
                                        }
                                    }
                                })
                            ),
                            m("div.text-center mb-5",
                                m("small.text-muted",
                                    m("span", "Need Help?"),
                                    m("a.text-muted font-weight-bold px-2", {
                                        "href": "tel:09777111811",
                                        "style": "text-decoration-line: underline; text-decoration-style: dotted; text-decoration-color: #6c757d"
                                    }, "09 777 111 811")
                                )
                            )
                        ]),

                        vnode.attrs.appContext.isLeavingExtraMarginBottom() ?
                            m("div.app-area-system-nav") : null
                    ])
            ]
        }

    }
}

export default HomePage;